<template>
  <div class="app-tabs">
    <el-tabs type="card" v-model="selected" @tab-click="onTabClick">
      <el-tab-pane v-for="item in tabItems"
        :key="item.index"
        :name="item.name"
        :label="item.label"
        :disabled="item.disabled">
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';
import { RoutesMap } from '@/router';

/**
 * ルーティング設定を参照して画面遷移するタブ
 */
@Component
export default class AppTabs extends AppComponent {
    /**
     * タブの選択肢として表示するルート設定
     */
    @Prop({require: true})
    routes;

    data () {
      return {
        selected: null,
        tabItems: []
      }
    }

    /**
     * 初期化
     */
    initialize () {
      if (this.routes === null) {
        return;
      }

      let index = 0;
      this.routes.forEach(route => {
        if (route.name in RoutesMap) {
          this.tabItems.push({
            index: index++,
            name: route.name,
            label: RoutesMap[route.name].title,
            disabled: false
          });
        } else {
          throw new Error('Invalid route name ' + route.name);
        }
      });

      this.selected = this.$route.name;
    }

    /**
     * タブクリックイベント
     */
    onTabClick (vueComponent, event) {
      // 指定されたページへ遷移する
      if (this.selected !== this.$route.name) {
        const route = this.routes[vueComponent.index];
        this.$router.push(route);
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/AppTabs.vue